import { type useBooleanState } from '@cian/react-utils';
import { Button, CustomTooltip } from '@cian/ui-kit';
import { IconActionSort16, IconFunctionalSuccess16 } from '@cian/ui-kit-design-tokens/icons';

import { type RefObject, forwardRef } from 'react';

import { type SortType } from '@/packages/api-models/common/json_query';

import { type IOption } from '../../utils/Option';

import styles from './SortListingButton.css';

type SortListingButtonProps = {
  activeItem: IOption<string, SortType>;
  dropdownVisibilityState: ReturnType<typeof useBooleanState>;
  items: Array<IOption<string, SortType>>;
  onItemClick(item: IOption<string, SortType>): void;
  dataTestId: string;
};

export const SortListingButton = forwardRef<HTMLButtonElement, SortListingButtonProps>(
  function SortListingButton(props, ref) {
    const { activeItem, dataTestId, onItemClick, items, dropdownVisibilityState } = props;

    return (
      <>
        <Button
          beforeIcon={<IconActionSort16 color="accent-main-primary" />}
          data-testid={dataTestId}
          ref={ref}
          size="XS"
          theme="fill_white_primary"
          onClick={dropdownVisibilityState.setTrue}
        >
          {activeItem.value === 'default' ? '' : activeItem.label}
        </Button>
        <CustomTooltip
          outside
          portal
          withoutPadding
          anchorRef={ref as RefObject<HTMLButtonElement>} // @todo ошибка в типизации в ките, отписал в чат, должны исправить. Будущий разработчик проверь, что исправили или снова напиши в чат и пингани мийнтейнеров
          arrow={false}
          closeButton={false}
          content={
            <ul className={styles['list']} data-testid="sorting-button-tooltip">
              {items.map(item => {
                const isActive = activeItem.value === item.value;

                const handleItemClick = (): void => {
                  onItemClick(item);
                };

                return (
                  <li
                    className={styles['item']}
                    data-testid={`sorting-option.${item.value}`}
                    key={item.value}
                    onClick={handleItemClick}
                  >
                    {item.label}
                    {isActive && <IconFunctionalSuccess16 color="accent-main-primary" />}
                  </li>
                );
              })}
            </ul>
          }
          flip={false}
          maxWidth={500}
          open={dropdownVisibilityState.state}
          placement="bottom-start"
          preventOverflow={false}
          size="S"
          theme="white"
          onClose={dropdownVisibilityState.setFalse}
        />
      </>
    );
  },
);
